<template>
  <div id="shra2019">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>上海路政</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       :clearable="true"
                       placeholder="请选择客户"
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="路政场库编号::"
                        label-width="100px">
            <el-input placeholder="请输入路政场库编号"
                      v-model="pageSearch.fShraParkNo"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="传输模式::">
            <el-select v-model="pageSearch.fTransType"
                       clearable
                       placeholder="请选择传输方式">
              <el-option v-for="item in fTransTypeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="parkList"
                  border
                  highlight-current-row
                  style="width: 100%"
                  v-if="isShowPark"
                  ref="parkTable">
          <el-table-column width="50"
                           label="序号"
                           align="right"
                           prop="fIndex">
          </el-table-column>
          <el-table-column prop="fOpLastTimeName"
                           width="160"
                           label="最后同步时间">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           width="160"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           width="80"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           width="160"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fParkTypeName"
                           width="100"
                           label="场库类型">
          </el-table-column>
          <el-table-column prop="fParkCount"
                           width="80"
                           align="right"
                           label="车位数量">
          </el-table-column>
          <el-table-column prop="fResCount"
                           width="80"
                           align="right"
                           label="保留数量">
          </el-table-column>
          <el-table-column prop="fAddress"
                           label="场库地址">
          </el-table-column>
          <el-table-column fixed="right"
                           align="center"
                           label="操作"
                           width="100">
            <template slot-scope="scope">
              <el-button @click="viewPark(scope.row)"
                         type="success"
                         size="mini">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="mqttList"
                  v-if="isShowMqtt"
                  highlight-current-row
                  :row-class-name="mqttTableRowClassName"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           prop="fIndex"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCltTime"
                           label="客户端时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fCustName"
                           width="160"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fPriIP"
                           width="125"
                           label="IP">
          </el-table-column>
          <el-table-column prop="fProgName"
                           label="程序名称">
          </el-table-column>
          <el-table-column prop="fProgVer"
                           align="right"
                           width="110"
                           label="程序版本">
          </el-table-column>
          <el-table-column prop="fMQTTSvr"
                           label="MQTT服务器">
          </el-table-column>
          <el-table-column prop="fPayName"
                           label="电子支付">
          </el-table-column>
          <el-table-column prop="fMQTTStatus"
                           width="100"
                           label="MQTT状态"
                           :formatter="rowFormatter">
          </el-table-column>
        </el-table>
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fParkCount"
                           align="right"
                           label="场库车位数">
          </el-table-column>
          <el-table-column prop="fShraParkNo"
                           label="路政场库编号">
          </el-table-column>
          <el-table-column prop="fSRParkCount"
                           align="right"
                           label="上报路政车位数">
          </el-table-column>
          <el-table-column prop="fTransType"
                           label="数据传输">
          </el-table-column>
          <el-table-column prop="fLastTransTime"
                           width="150"
                           label="最后传输时间">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10,20,100, 500, 1000]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="65%"
               id="shra2019Dialog"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <!-- <el-row class="log_search">
        <el-col :span="24">
          <el-select v-model="deviceLogParam.fIsExp"
                     placeholder="请选择日志类型"
                     clearable>
            <el-option v-for="item in logTypeArray"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input placeholder="请输入监控项目"
                    v-model="deviceLogParam.searchKeyWord"
                    class="search">
          </el-input>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="init_log">查询</el-button>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-table :data="pageLogData"
                    v-loading="logLoading"
                    :row-class-name="tableRowClassName"
                    height="500"
                    border
                    stripe
                    style="width: 100%">
            <el-table-column width="50"
                            type="index"
                           :index="logIndexMethod"
                           align="right"
                             label="序号">
            </el-table-column>
            <el-table-column prop="fCustNo"
                             label="客户编号"
                             width="80">
            </el-table-column>
            <el-table-column prop="fOpLastTime"
                             label="最后操作时间"
                             width="170">
            </el-table-column>
            <el-table-column prop="fTransTypeName"
                             width="100"
                             label="数据传输">
            </el-table-column>
            <el-table-column prop="fTransData"
                             width="120"
                             label="传输数据">
            </el-table-column>
            <el-table-column prop="fStatusName"
                             width="80px"
                             label="状态">
            </el-table-column>
            <el-table-column prop="fRemark"
                             label="备注">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="pagination">
        <el-col :span="24">
          <div class="block">
            <span class="demonstration"></span>
            <el-pagination @current-change="handleLogCurrentChange"
                           @size-change="handleLogSizeChange"
                           :current-page="pageLogSearch.pageIndex"
                           :page-size="pageLogSearch.pageSize"
                           :page-sizes="[10,20,100, 500, 1000]"
                           background
                           layout="total,sizes, prev, pager, next, jumper"
                           :total="pageLogCount"
                           v-if="pageLogCount>0">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <parkView ref="child"
              :parkActiveName="parkActiveName"
              :choiceCusts="cust_list"></parkView>
  </div>
</template>
<script>
import parkView from '../../components/parkView'
import { device as api } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  components: { parkView },
  data () {
    return {
      tableHeight: 0,
      loading: false,
      logLoading: false,
      dialogTitle: '',
      dialogVisible: false,
      isShowPark: false,
      isShowMqtt: false,
      isShowOtherTable: false,
      parkActiveName: 'parkList',
      parkList: [],
      mqttList: [],
      pageLogData: [],
      pageData: [],
      cust_list: [],
      park_list: [],
      fTransTypeList: [{ text: '正常传输', value: '1' }, { text: '数据补传', value: '2' }],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fShraParkNo: '',
        fTransType: ''
      },
      pageLogCount: 0,
      pageLogSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fShraParkNo: ''
      }
    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.isShowPark = false
      this.isShowMqtt = false
      this.isShowOtherTable = false
      this.loading = true
      api.shra2019PageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      if ((this.pageSearch.fCustID.length > 0 && this.pageSearch.fParkID.length > 0) || (this.pageSearch.fShraParkNo || '').trim().length > 0) {
        api.shra2019ParkList(this.pageSearch).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.parkList = data.Data || []
              if (this.parkList.length > 0) {
                this.isShowPark = true
                api.shra2019DevList({ fCustID: this.parkList[0].fCustID }).then(res => {
                  if (res && res.data) {
                    var data = res.data
                    if (data.IsOk) {
                      this.mqttList = data.Data || []
                      if (this.mqttList.length > 0) {
                        this.isShowMqtt = true
                        this.isShowOtherTable = true
                      }
                    } else {
                      this.$message.error('提示：' + data.Msg)
                    }
                  }
                })
              }
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }
    },
    viewPark (row) {
      this.$refs.child.viewPark(row)
    },
    mqttTableRowClassName ({ row, rowIndex }) {
      if (row.fMQTTStatus === '0') {
        return 'warning-row'
      }
      return ''
    },
    initLog (index) {
      if (index && index >= 1) {
        this.pageLogSearch.pageIndex = index
      } else {
        this.pageLogSearch.pageIndex = 1
      }
      this.logLoading = true
      api.shra2019LogPageList(this.pageLogSearch).then(res => {
        this.logLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageLogData = data.Data.data
            this.pageLogCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    rowFormatter (row, column, cellValue, index) {
      if (cellValue === '1') {
        return '已连接'
      } else {
        return '未连接/异常'
      }
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    logIndexMethod (index) {
      return this.pageLogSearch.pageSize * (this.pageLogSearch.pageIndex - 1) + index + 1
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsError === '1') {
        return 'warning-row'
      }
      return ''
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleLogSizeChange (val) {
      this.pageLogSearch.pageSize = val
      this.initLog(this.pageLogSearch.pageIndex)
    },
    handleLogCurrentChange (val) {
      this.initLog(val)
    },
    setTableHeight (obj) {
      if (this.isShowOtherTable) {
        let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 350
        obj.tableHeight = clientHeight
      } else {
        let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 205
        obj.tableHeight = clientHeight
      }
    },
    handleInfo (index, row) {
      this.dialogTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】查看路政日志信息'
      this.pageLogSearch.pageIndex = 1
      this.pageLogSearch.pageSize = 20
      this.pageLogSearch.fCustID = row.fCustID
      this.pageLogSearch.fShraParkNo = row.fShraParkNo
      this.dialogVisible = true
      this.initLog()
    },
    loadOptions () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      this.pageSearch.fChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 76000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    // this.init()
    this.loadOptions()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#shra2019Dialog .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#shra2019Dialog .el-dialog__title {
  color: white;
}
#shra2019Dialog .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#shra2019Dialog .el-dialog__body {
  padding: 10px 10px;
}
#shra2019 .is-disabled .el-input__inner,
#shra2019 .is-disabled .el-textarea__inner {
  color: #606266;
}
#shra2019 .fRemark_item .el-form-item__content {
  height: auto;
}
#shra2019 .warning-row {
  color: #f56c6c;
}
</style>
<style scoped>
#shra2019 .rowsData {
  border: 1px solid #dcdfe6;
  padding: 5px;
  overflow: auto;
}
.el-form-item {
  margin-bottom: 10px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#shra2019 .page-row {
  font-size: 16px;
}
#shra2019 .el-table__empty-text {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/shra2019.vue